import { useQuery } from '@tanstack/react-query';
import type { ToolPart } from '../../types';
import { skillsQueryOptions, skillLabel } from '../../queries/skills-queries';

interface Props {
  part: ToolPart;
}

export function SkillCard({ part }: Props) {
  const skillId = (part.state.input?.skill_name as string | undefined) || 'unknown';
  // Skills catalogue is process-wide and cached forever (see skillsQueryOptions).
  // In the rare case it hasn't loaded yet, fall back to the technical id.
  const { data: skills } = useQuery(skillsQueryOptions());
  const found = skills?.find((s) => s.name === skillId);
  const skillName = found ? skillLabel(found) : skillId;
  const isActive = part.state.status === 'running';
  const isError = part.state.status === 'error';
  const dotClass = isError
    ? 'tool-dot-error'
    : isActive
      ? 'tool-dot-active'
      : 'tool-dot-done';

  const label = isActive
    ? `Активирую навык: ${skillName}…`
    : isError
      ? `Не удалось активировать навык: ${skillName}`
      : `Подключен навык: ${skillName}`;

  const hasBody = !!part.state.output && !isError;

  return (
    <div className={`tool-step tool-${part.state.status}`}>
      <div className="tool-step-rail">
        <div className={`tool-step-dot ${dotClass}`} />
      </div>
      <div className="tool-step-body">
        {hasBody ? (
          <details>
            <summary className={`tool-step-label ${isActive ? 'tool-active' : ''}`}>
              {label}
            </summary>
            <div className="tool-step-content">
              <pre className="tool-output">{part.state.output}</pre>
            </div>
          </details>
        ) : (
          <div className={`tool-step-label ${isActive ? 'tool-active' : ''}`}>{label}</div>
        )}
        {isError && part.state.error && (
          <div className="tool-step-content">
            <pre className="tool-error">{part.state.error}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
